import React, { useState } from 'react'

import useFetch from 'hooks/useFetch'

import { Container, ContentHeader, LoadingFeedback, Page } from 'components'
import { PdcaForm } from './components'

import * as service from 'service'

const PdcaEdit = ({ match }) => {
  const { pdcaId } = match.params
  const [loading, setLoading] = useState(false)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.pdca.show,
    { pdcaId },
    [pdcaId],
    !!pdcaId,
  )

  const DataPdca = response?.data?.monitoringManagementPdca

  return (
    <Page title="Editar PDCA">
      <Container maxWidth={false}>
        <LoadingFeedback open={loading || isLoading} />
        <ContentHeader title="Editar PDCA" />

        {!isLoading && (
          <PdcaForm
            setLoading={setLoading}
            dataPdca={DataPdca}
            refresh={refresh}
            mode="edit"
          />
        )}
      </Container>
    </Page>
  )
}

export default PdcaEdit
